import { render, staticRenderFns } from "./ios.vue?vue&type=template&id=6baffc74&scoped=true&"
import script from "./ios.vue?vue&type=script&lang=ts&"
export * from "./ios.vue?vue&type=script&lang=ts&"
import style0 from "./ios.vue?vue&type=style&index=0&id=6baffc74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baffc74",
  null
  
)

export default component.exports